var _path, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOurEmployee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.58 70.9999C140.58 109.435 109.435 140.58 70.9999 140.58C32.5653 140.58 1.41992 109.435 1.41992 70.9999C1.41992 32.5653 32.5653 1.41992 70.9999 1.41992C109.435 1.41992 140.58 32.5653 140.58 70.9999Z",
    fill: "url(#paint0_linear_1545_9260)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1545_9260)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.0009,
    cy: 70.9999,
    r: 61.3872,
    stroke: "#FFC25D",
    strokeWidth: 4.07895
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1545_9260)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.162 24.437L66.1467 28.2438C66.072 28.3931 65.96 28.4677 65.7734 28.5051L61.5188 29.2515C60.3618 29.4381 59.3915 30.2965 59.0182 31.4161C58.645 32.5358 58.9436 33.7674 59.7647 34.6258L62.7504 37.7235C62.8624 37.8354 62.8997 37.9847 62.8997 38.134L62.3025 42.3887C62.1159 43.5456 62.6384 44.7399 63.5715 45.449C64.5418 46.1581 65.8108 46.2701 66.8558 45.7476L70.7372 43.8442C70.8865 43.7696 71.0358 43.7696 71.1851 43.8442L75.0665 45.7476C76.1488 46.2701 77.3804 46.1581 78.3508 45.449C79.3211 44.7399 79.8063 43.583 79.6197 42.3887L79.0226 38.134C78.9853 37.9847 79.0599 37.8354 79.1719 37.7235L82.1576 34.6258C82.9787 33.7674 83.2772 32.5358 82.904 31.4161C82.5308 30.2965 81.5604 29.4381 80.4035 29.2515L76.1488 28.5051C75.9995 28.4677 75.8503 28.3931 75.7756 28.2438L73.7602 24.437C73.2004 23.392 72.1181 22.7202 70.9238 22.7202C69.8042 22.7202 68.7218 23.3547 68.162 24.437Z",
    fill: "#FFC25D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.29 37.0517L100.185 38.3206C100.036 38.358 99.8865 38.358 99.7372 38.246L96.229 35.7455C95.2586 35.0737 93.9897 34.9617 92.9447 35.5215C91.8997 36.044 91.2279 37.1264 91.1906 38.3206L91.1159 42.6126C91.1159 42.7619 91.0413 42.9112 90.9293 42.9858L87.4957 45.561C86.5627 46.2701 86.0775 47.4644 86.2641 48.6214C86.4507 49.7784 87.2718 50.7487 88.3914 51.1593L92.4595 52.5401C92.6088 52.5775 92.7207 52.6894 92.7581 52.8387L94.139 56.9814C94.5122 58.1011 95.4825 58.9221 96.6768 59.1087C97.8338 59.2953 99.0281 58.8102 99.7372 57.8771L102.312 54.4435C102.387 54.3316 102.536 54.2569 102.686 54.2569L106.978 54.1823C108.172 54.1823 109.254 53.5105 109.777 52.4282C110.299 51.3832 110.225 50.1142 109.553 49.1439L107.09 45.6357C107.015 45.5237 106.978 45.3371 107.015 45.1878L108.284 41.0824C108.62 39.9628 108.321 38.7312 107.5 37.8728C106.679 37.0144 105.447 36.6785 104.29 37.0517Z",
    fill: "#FFC25D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7146 41.0452L34.9835 45.1506C35.0208 45.2998 35.0208 45.4491 34.9089 45.5984L32.4457 49.1066C31.7739 50.077 31.6619 51.3459 32.2217 52.3909C32.7442 53.4359 33.8265 54.1077 35.0208 54.145L39.3128 54.2197C39.4621 54.2197 39.6114 54.2943 39.686 54.4063L42.2612 57.8399C42.9703 58.7729 44.1646 59.2581 45.3216 59.0715C46.4785 58.8849 47.4489 58.0638 47.8594 56.9442L49.2403 52.8761C49.2777 52.7268 49.3896 52.6149 49.5389 52.5775L53.607 51.1966C54.7266 50.8234 55.5477 49.8531 55.7343 48.6588C55.9209 47.5018 55.4357 46.3075 54.5027 45.5984L51.0691 43.0232C50.9571 42.9486 50.8825 42.7993 50.8825 42.65L50.8078 38.3207C50.8078 37.1264 50.1361 36.0441 49.0537 35.5216C48.0087 34.9991 46.7398 35.0737 45.7694 35.7455L42.2612 38.2461C42.1493 38.3207 41.9626 38.358 41.8134 38.3207L37.708 37.0518C36.5883 36.7159 35.3567 37.0145 34.4983 37.8355C33.6399 38.6939 33.3414 39.9255 33.7146 41.0452Z",
    fill: "#FFC25D"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1545_9260)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.028 85.3825C104.028 88.0697 102.199 90.0477 100.557 91.7645C99.6612 92.6976 98.7655 93.6679 98.5416 94.377C98.3032 95.1261 98.4377 96.3102 98.5765 97.5324L98.5768 97.5349C98.59 97.6515 98.6032 97.7684 98.6162 97.8853C98.9148 100.199 99.2134 102.849 97.7205 104.939C96.1642 107.051 93.6146 107.545 91.3136 107.99L91.2639 107.999C91.1933 108.014 91.1225 108.028 91.0515 108.043C90.9762 108.058 90.9008 108.073 90.8254 108.088C89.696 108.315 88.5786 108.54 88.0169 108.97C87.4127 109.396 86.8084 110.5 86.2042 111.603L86.1135 111.769C85.0312 113.859 83.7249 116.21 81.2244 117.031C80.6646 117.218 80.0674 117.292 79.5076 117.292C77.7617 117.292 76.0837 116.51 74.5388 115.79L74.3199 115.688C73.1256 115.09 71.8567 114.493 70.9983 114.493C70.1399 114.493 68.9083 115.09 67.6767 115.688C65.5867 116.695 63.1981 117.815 60.7722 117.031C58.2717 116.21 57.0027 113.859 55.8831 111.769L55.7925 111.603C55.1882 110.5 54.5839 109.396 53.9797 108.97C53.3452 108.485 52.039 108.223 50.7327 107.999L50.6568 107.985C48.3619 107.541 45.7896 107.043 44.2761 104.939C42.7459 102.849 43.0818 100.199 43.3804 97.8853C43.3923 97.7778 43.4045 97.6701 43.4167 97.5624L43.4167 97.5623L43.4167 97.5622C43.5567 96.3244 43.6953 95.098 43.455 94.377C43.2488 93.724 42.4412 92.8494 41.6443 91.9865L41.6428 91.9848C41.5749 91.9113 41.507 91.8378 41.4397 91.7645L41.4074 91.7301C39.81 90.0213 37.9688 88.0517 37.9688 85.3825C37.9688 82.6954 39.7975 80.7174 41.4397 79.0006C41.5073 78.927 41.5754 78.8533 41.6436 78.7795L41.6442 78.7787L41.6443 78.7786C42.4412 77.9157 43.2488 77.0411 43.455 76.3881C43.6934 75.6389 43.5589 74.4549 43.4202 73.2327C43.4068 73.1153 43.3935 72.9976 43.3804 72.8798C43.0818 70.5659 42.7832 67.9161 44.2761 65.8261C45.8324 63.7139 48.382 63.2206 50.683 62.7753L50.7327 62.7657C50.8782 62.7357 51.0247 62.7063 51.171 62.6768L51.1712 62.6768L51.1712 62.6768C52.3006 62.4496 53.418 62.2249 53.9797 61.7953C54.5839 61.3688 55.1882 60.2652 55.7924 59.1617L55.8831 58.9962C56.9654 56.9062 58.2717 54.555 60.7722 53.7339C63.1221 52.9385 65.4021 53.9993 67.4423 54.9485L67.6394 55.0401C68.8337 55.6373 70.1026 56.2344 70.961 56.2344C71.8145 56.2344 73.0738 55.6441 74.2621 55.0871L74.2826 55.0775C76.3726 54.0698 78.7612 52.9501 81.1871 53.7339C83.7249 54.555 84.9939 56.9062 86.1135 58.9962L86.2042 59.1617C86.8084 60.2652 87.4127 61.3688 88.0169 61.7953C88.6514 62.2805 89.9576 62.5418 91.2639 62.7657L91.3398 62.7804C93.6348 63.2243 96.207 63.722 97.7205 65.8261C99.2507 67.9161 98.9148 70.5659 98.6162 72.8798L98.5971 73.0507L98.5799 73.203C98.4399 74.4407 98.3013 75.6671 98.5416 76.3881C98.7478 77.0411 99.5554 77.9157 100.352 78.7786L100.352 78.7786C100.421 78.8527 100.489 78.9268 100.557 79.0006L100.589 79.035C102.187 80.7438 104.028 82.7134 104.028 85.3825ZM75.999 79.8966C75.999 81.1655 74.9913 82.1732 73.7224 82.1732L69.3931 82.1359V83.0689H70.9606C72.2295 83.0689 73.2372 84.0766 73.2372 85.3455C73.2372 86.6145 72.2295 87.6221 70.9606 87.6221H69.3931V88.5552H73.7224C74.9913 88.5552 75.999 89.5629 75.999 90.8318C75.999 92.1007 74.9913 93.1084 73.7224 93.1084H67.1538C65.8849 93.1084 64.8772 92.1007 64.8772 90.8318V79.8966C64.8772 78.6276 65.8849 77.62 67.1538 77.62H73.7224C74.9913 77.62 75.999 78.6276 75.999 79.8966ZM60.5855 77.6574C59.3166 77.6574 58.3089 78.6651 58.3089 79.934V82.6958L55.9577 78.7771C55.4352 77.9187 54.3902 77.4708 53.4198 77.7694C52.4494 78.0306 51.7403 78.9263 51.7403 79.9713V90.9066C51.7403 92.1755 52.748 93.1832 54.0169 93.1832C55.2859 93.1832 56.2936 92.1755 56.2936 90.9066V88.1448L58.6448 92.0635C59.0553 92.7726 59.8018 93.1832 60.5855 93.1832C60.7721 93.1832 60.9961 93.1458 61.1827 93.1085C62.153 92.8473 62.8621 91.9516 62.8621 90.9066V79.9713C62.8621 78.6651 61.8545 77.6574 60.5855 77.6574ZM85.7029 79.934C85.7029 78.6651 86.7106 77.6574 87.9796 77.6574C89.2485 77.6574 90.2562 78.6651 90.1815 79.934V90.8692C90.1815 91.8396 89.5844 92.7353 88.6513 93.0339C88.4274 93.1085 88.1662 93.1458 87.9422 93.1458C87.2704 93.1458 86.5987 92.81 86.1508 92.2501L83.5756 88.8539L81.0004 92.2501C80.4033 93.0339 79.3956 93.3698 78.4626 93.0339C77.5669 92.698 76.9324 91.8396 76.9324 90.8692V79.934C76.9324 78.6651 77.9401 77.6574 79.209 77.6574C80.4779 77.6574 81.4856 78.6651 81.4856 79.934V84.1514L81.7842 83.7408C82.6426 82.6212 84.546 82.6212 85.4044 83.7408L85.7029 84.1514V79.934Z",
    fill: "#FFC25D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1545_9260",
    x: 7.57422,
    y: 7.57324,
    width: 126.854,
    height: 128.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9260"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1545_9260",
    x: 31.8633,
    y: 22.7202,
    width: 78.2559,
    height: 38.0598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9260"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1545_9260",
    x: 37.9688,
    y: 53.4546,
    width: 66.0586,
    height: 65.4714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63158
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.815789
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1545_9260"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1545_9260",
    x1: 22.7199,
    y1: 16.5666,
    x2: 124.25,
    y2: 115.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDD2C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOurEmployee);
export default __webpack_public_path__ + "static/media/IconOurEmployee.963ed87b7424bf13a54c324584ccc752.svg";
export { ForwardRef as ReactComponent };